import VendSize from './VendSize'
import Flavor from './Flavor'
import CardReader from './CardReader'
import SecurityLevel from './SecurityLevel'
import BaseLineItemEntity from '../baseclasses/BaseLineItemEntity'
import * as _ from "lodash";
export class VendorLineItem extends BaseLineItemEntity{
    ID?: number;
    VendSizeID?: number;
    VendSize?: VendSize;
    FlavorID?: number;
    Flavor?: Flavor;
    CardReaderID?: number;
    //CardReader?: CardReader;
    SecurityLevelID?: number;
    //SecurityLevel?: SecurityLevel;
    VendPrice?: number;
    SetOnSite: boolean;
    Casters: boolean;
    MaterialNumber: string;
    MaterialDescription: string;
    EquipmentLocation: string;

    constructor() {
        super();
        this.VendSize = new VendSize();
        this.Flavor = new Flavor();
        //this.CardReader = new CardReader();
        //this.SecurityLevel = new SecurityLevel();
    }
    CloneShallow(): VendorLineItem{
        var newItem:VendorLineItem = _.clone(this);
        //newItem.CardReader = null;
        //newItem.SecurityLevel = null;
        newItem.Flavor = null;
        newItem.VendSize = null;
        return newItem;
    }
}

export default VendorLineItem;